export default __webpack_public_path__ + "assets/images/g-icon6-2296c2f3.svg";